export default __webpack_public_path__ + "static/PodCastWaterMark-d73991681f0f2605c2f8ecc56eb27524.svg";